import { useMemo } from 'react'

import { FieldsWidgetType } from 'features/views/LayoutEditor/widgets/FieldsWidget/fieldWidgetTypes'
import { useRecordManagerContext } from 'features/views/RecordManager/useRecordManagerContext'

import { useFieldsWidgetFields } from './useFieldsWidgetFields'

type UseFieldsWidgetStateProps = {
    widget: FieldsWidgetType
}

export function useFieldsWidgetState({ widget }: UseFieldsWidgetStateProps) {
    const { record, isLoadingSlow } = useRecordManagerContext()

    const { visibleFields } = useFieldsWidgetFields(widget)

    const showFieldIcon = widget.attrs.showFieldIcon ?? false
    const labelPlacement = widget.attrs.labelPlacement || 'top'

    const hasFields = visibleFields.length > 0
    const hasRecord = !!record

    return useMemo(
        () => ({
            record,
            isLoadingSlow,
            showFieldIcon,
            labelPlacement,
            hasFields,
            hasRecord,
            fields: visibleFields,
        }),
        [record, isLoadingSlow, showFieldIcon, labelPlacement, hasFields, hasRecord, visibleFields]
    )
}
